import Box from '@mui/material/Box';
import { ElementType } from 'react';

import { TypographyIcon } from '../TypographyIcon/TypographyIcon';

export const CardIconList = ({ items }: { items: { icon: ElementType; label: string }[] }) => {
  return (
    <Box>
      {items.map(({ icon, label }, index) => {
        if (!label.length) {
          return null;
        }
        return (
          <Box
            key={index + label}
            sx={{
              display: 'flex',
              alignItems: 'center',
              mb: 1,
            }}
          >
            <TypographyIcon
              size="small"
              variant="body2"
              icon={icon}
              noWrap
              textOverflow="ellipsis"
              overflow="hidden"
              maxWidth="250px"
              data-testid="card-icon-list-item"
            >
              {label}
            </TypographyIcon>
          </Box>
        );
      })}
    </Box>
  );
};
